export const MAX_FILE_SIZE_10MB = 10000000;
